export default __webpack_public_path__ + "static/media/person-gray-small.3ad527df.svg";